// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__11Uqo","label":"SetPasswdForm_label__ZSJjt"};